import { cn } from "@/lib/utils";
import { LogoCloud } from "@/components/ui/logo-cloud-4";

const logos = [
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090471/nsn_rtusl1.png",
    alt: "NSN Logo",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090429/bbci_jekoss.png",
    alt: "BBCI Logo",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090252/hmo_c9xwaf.png",
    alt: "HMO Logo",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090090/ggh_vvhxui.png",
    alt: "GGH Logo",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090471/nsn_rtusl1.png",
    alt: "NSN Logo 2",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090429/bbci_jekoss.png",
    alt: "BBCI Logo 2",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090252/hmo_c9xwaf.png",
    alt: "HMO Logo 2",
  },
  {
    src: "https://res.cloudinary.com/dihr82npb/image/upload/v1775090090/ggh_vvhxui.png",
    alt: "GGH Logo 2",
  },
];

export default function LogoCloudDemo() {
  return (
    <div className="relative w-full place-content-center px-4 py-12">
      <div
        aria-hidden="true"
        className={cn(
          "-top-1/2 -translate-x-1/2 pointer-events-none absolute left-1/2 h-[120vmin] w-[120vmin] rounded-b-full",
          "bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.1),transparent_50%)]",
          "blur-[30px]"
        )}
      />
      <div className="w-full">
        <h2 className="mb-5 text-center">
          <span className="block font-medium text-2xl text-muted-foreground">
            Community Partners
          </span>
        </h2>

        <LogoCloud logos={logos} />
      </div>
    </div>
  );
}
